<template>
  <div class="toast">
    <img
      class="icon"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bbc136ea67aeb8ae1eadba17edf903bf.png"
      alt=""
    />
    <div class="title">转换失败</div>
    <div class="message"
      ><span class="m-span" v-html="toastOptions.message"></span
    ></div>
    <div class="btn-list">
      <div class="btn-item" @click="bindCancel">去积分商城</div>
      <div class="btn-item confirm-btn" @click="bindConfirm">知道啦</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      defaultOptions: {
        icon: '',
        title: '标题',
        message: '描述',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }
    }
  },
  computed: {
    toastOptions() {
      return Object.assign({}, this.defaultOptions, this.options)
    }
  },
  methods: {
    bindCancel() {
      this.$emit('cancel')
    },
    bindConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  padding: 16px 20px 20px;
  box-sizing: border-box;
  width: 295px;
  background: #ffffff;
  border-radius: 12px;
  animation: myscale 0.3s ease;

  .icon {
    margin: 0 auto 6px;
    width: 68px;
    height: 68px;
    object-fit: contain;
  }

  .title {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }

  .message {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.7);
    line-height: 20px;
    margin-bottom: 16px;
    .m-span {
      display: inline-block;
      text-align: left;
    }
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-item {
      box-sizing: border-box;
      width: 120px;
      height: 44px;
      border-radius: 22px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgba(250, 44, 25, 0.3);
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fa2c19;
      margin-right: 14px;
    }

    .btn-item:last-child {
      margin-right: 0;
    }

    .confirm-btn {
      background: #fa2c19;
      color: #fff;
    }
  }
}
@keyframes myscale {
  0% {
    transform: scale(0.3);
  }
  80% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
